import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsMentorSelectedTutorial } from "../../Redux/slices/tutorialSlice";

const TutorialRouteListener = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const isTutorialInURL = location.pathname.includes("tutorials");
    const isExerciseInURL = location.pathname.includes("exercises");
    (isExerciseInURL || isTutorialInURL) &&
      dispatch(setIsMentorSelectedTutorial(isTutorialInURL));
  }, [location, dispatch]);

  return null; // This component only runs side-effects
};

export default TutorialRouteListener;
